import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { getLocationType } from '../../actions/userActions/locationTypeAction';
import Loader from '../subComponents/Loader';
import Search from '../subComponents/search/Search';
import Pagination from '../paginatioin/pagination';
import AddButton from '../subComponents/buttons/AddButton';
import { IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from '../../actions/types';
import DynamicTable from '../reuse_components/DynamicTable';

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import BodySmallMedium from '../designSystem/BodySmallMedium';
import Heading6Regular from '../designSystem/Heading6Regular';
import SearchInput from '../subComponents/search/SearchInput';
import CustomPagination from '../subComponents/pagination/CustomPagination';
import CustomButton from '../subComponents/buttons/CustomButton';
import AddLocationTypes from './AddLocationTypes';
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from '../../locales/translate';
function LocationTypes() {
    const [isExpanded, setIsExpanded] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [query, setQuery] = useState("");
    const [previousQuery, setPreviousQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [locationTypeData, setlocationTypeData] = useState([]);
    const firstPage = 1;
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const isLoading = useSelector((state) => state.location_type_reducer.isLocationTypeLoading);
    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        const pageNumber = currentPage;
        if (query !== previousQuery) {
            setCurrentPage(1);
        }
        dispatch(getLocationType(pageNumber, itemsPerPage, query));
        setPreviousQuery(query);
    }, [currentPage, query, previousQuery, dispatch]);

    const locationTypesData = useSelector(
        (state) => state.location_type_reducer.locationTypes
    );
   const permissions = JSON.parse(localStorage.getItem('permissionsList')) || [];
  useEffect(() => {
    const practicelocationTypeData = locationTypesData?.result || [];
    setlocationTypeData(practicelocationTypeData);
  }, [locationTypesData]);
  
  const totalPages = locationTypesData?.totalPages || 0;
  const totalItems = locationTypesData?.totalCount || 0;
    const columns = [
      { label: `${t("name")}`, accessor: "name" },
      { label: `${t("description")}`, accessor: "description" },
     
    ];
     const handleEditLocationType = (row) => {
        setEditData(row);
        setShowModal(true);
      };
    const actions = [  
      {
          label: 'Edit Location Type',
          icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
          permission: 'CanUpdatePracticeLocationType',
          handler:handleEditLocationType,
      },
  ];
  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };
  
const handleAddPracticeLocationTypeClick = () => {
    setEditData(null);
    setShowModal(true);
  };
  
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getLocationType(pageNumber, value, query));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleSaveData = () => {
    dispatch(getLocationType(currentPage, itemsPerPage, query));
    setShowModal(false);
  };
  
    return (
        <>
        <div>
          <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
           <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
              value={query}
                    />
                 <div className="flex-align-center">
                 <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                        <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                    
                        {permissions && permissions.includes("CanAddPracticeLocationType") && (
                            <CustomButton text="Add New" onClick={handleAddPracticeLocationTypeClick} />
                        )}
                    </div>
                </div>
               
            </div>
            <DynamicTable
                    data={ locationTypeData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
            {showModal && (
        <AddLocationTypes
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
        </div>                   
        </div>
  
        </>
    );
}

export default LocationTypes;
